export class ShiftMakerSettings {
  segmentsPerHour: number = 4;
  segmentRoundingPoint: number = 5;
}
